"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearch = exports.UNIVERSAL_SEARCH_MAX_HEIGHT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const router_1 = require("@reach/router");
const clsx_1 = __importDefault(require("clsx"));
const react_2 = require("react");
const semantic_ui_react_1 = require("semantic-ui-react");
const context_1 = require("../layout/context");
const navigation_1 = require("../navigation");
const help_1 = require("./help");
exports.UNIVERSAL_SEARCH_MAX_HEIGHT = 78;
const UniversalSearch = ({ isLoading, onQuery, children, timezone, email }) => {
    const location = (0, router_1.useLocation)();
    const searchInputRef = (0, react_2.useRef)(null);
    const [isOpen, setIsOpen] = (0, react_2.useState)(false);
    const [query, setQuery] = (0, react_2.useState)("");
    const [currentTime, setCurrentTime] = (0, react_2.useState)("");
    const [{ navigationState }] = (0, context_1.useLayoutContext)();
    const { womOrigin } = (0, navigation_1.useWomUrlInfo)();
    (0, react_2.useEffect)(() => {
        function formatTime() {
            setCurrentTime(new Date().toLocaleString(undefined, {
                month: "short",
                day: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                timeZone: timezone,
                timeZoneName: "short",
            }));
        }
        formatTime();
        const interval = setInterval(formatTime, 1000);
        return () => clearInterval(interval);
    }, [timezone]);
    const handler = (0, react_2.useCallback)((e) => {
        switch (e.type) {
            case "click":
            case "wom_click":
                setIsOpen(false);
                break;
            case "keydown":
            case "wom_keydown":
                if (e.key === "Escape")
                    setIsOpen(false);
                break;
        }
    }, []);
    (0, react_2.useEffect)(() => {
        document.addEventListener("click", handler);
        document.addEventListener("keydown", handler);
        document.addEventListener("wom_click", handler);
        document.addEventListener("wom_keydown", handler);
        return () => {
            document.removeEventListener("click", handler);
            document.removeEventListener("keydown", handler);
            document.removeEventListener("wom_click", handler);
            document.removeEventListener("wom_keydown", handler);
        };
    }, [handler]);
    (0, react_2.useEffect)(() => {
        setIsOpen(false);
    }, [location.href]);
    const handleInputChange = ({ target }) => {
        const val = target.value;
        setQuery(val);
        if (searchInputRef.current)
            clearTimeout(searchInputRef.current);
        if (!val) {
            setIsOpen(false);
            onQuery("");
            return;
        }
        searchInputRef.current = setTimeout(() => {
            setIsOpen(true);
            onQuery(val);
        }, 500);
    };
    const handleClear = () => {
        setQuery("");
        setIsOpen(false);
        onQuery("");
    };
    const handleInputClickFocus = () => {
        if (query)
            setIsOpen(true);
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: styles }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.default)("p-5 bg-white universal-search-input-padding", {
                mobile: navigationState !== "desktop",
            }) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex flex-wrap space-x-3 universal-search-input-container items-center", onClick: e => e.stopPropagation() }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex-1" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "universal-search-input-wrap" }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Input, Object.assign({ iconPosition: "left", fluid: true, loading: isLoading, onChange: handleInputChange, onFocus: handleInputClickFocus, onClick: handleInputClickFocus }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "search", className: "universal-search-input-icon" }), (0, jsx_runtime_1.jsx)("input", { value: query, className: "universal-search-input-element border-transparent bg-color-primary", placeholder: "Search for an ASN, Order, RMA, or SKU" })] })), query && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "times", link: true, className: "universal-search-clear-icon", onClick: handleClear }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "universal-search-results" }, { children: isOpen && children }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "universal-search-help-button" }, { children: (0, jsx_runtime_1.jsx)(help_1.UniversalSearchHelpModal, { triggerElement: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, Object.assign({ icon: true, className: "universal-search-info-button" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "question", size: "small" }) })) }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex items-center space-x-3 universal-search-right-controls" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "universal-search-time text-truncate" }, { children: currentTime })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown, Object.assign({ icon: null, trigger: (0, jsx_runtime_1.jsx)("button", Object.assign({ className: "universal-search-info-button" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "user circle", size: "big", style: { color: "#0d4f59" } }) })), pointing: "top right", onClick: e => e.stopPropagation() }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dropdown.Menu, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown.Item, { disabled: true, text: email }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown.Divider, {}), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown.Item, { text: "Settings", icon: "settings", as: "a", href: "settings" }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown.Divider, {}), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dropdown.Item, { text: "Logout", icon: "sign out", as: "a", href: `${womOrigin}/logout` })] }) }))] }))] })) })) })));
};
exports.UniversalSearch = UniversalSearch;
const styles = (0, react_1.css) `
  position: relative;

  .universal-search-input-padding {
    transition: padding 240ms 400ms ease-in;

    &.mobile {
      @media (min-width: 376px) {
        padding-left: 4.8rem;
      }
      padding-left: 4.8rem;
      padding-right: 4.8rem;
      transition: padding 400ms ease-in;
    }
  }

  .universal-search {
    &-input-icon.icon.search {
      opacity: 1 !important;
      color: var(--primary-color) !important;
    }

    &-input-element {
      padding-left: 3.2em !important;
      padding-right: 2.5em !important;
      border-color: transparent !important;
      background-color: #f1f3fa !important;
      transition: box-shadow 150ms ease, border-color 150ms ease !important;

      &:focus {
        outline: none !important;
        border-color: var(--primary-color) !important;
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 15%, transparent) !important;
      }
    }

    &-input-wrap {
      position: relative;
    }

    &-clear-icon {
      position: absolute !important;
      right: 0.75em !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
      color: rgba(0, 0, 0, 0.3) !important;
      cursor: pointer !important;
      z-index: 1;
      &:hover { color: rgba(0, 0, 0, 0.6) !important; }
    }

    &-results {
      position: relative;
    }

    &-info-button {
      margin: 0;
      width: 2.375em;
      height: 2.375em;
      border-radius: 50% !important;
    }

    &-help-button {
      @media (max-width: 815px) {
        padding-right: 4.8rem;
      }
    }

    &-left-controls {
      width: min(900px, 100%);
      flex-shrink: 1;

      @media (max-width: 815px) {
        width: calc(100% - 4.8rem);
      }
    }

    &-right-controls {
      flex: 1;
      justify-content: flex-end;
      min-width: max-content;

      @media (max-width: 815px) {
        flex-basis: 100%;
        margin-top: 0.5rem;
        margin-left: 0;
      }
    }

    &-time {
      font-size: 1.1rem;
      white-space: nowrap;
      overflow: hidden;
      max-width: 250px;
    }
  }
`;
